import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "requisites" }
const _hoisted_2 = { class: "requisites__container" }
const _hoisted_3 = { class: "requisites__block" }
const _hoisted_4 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_5 = { class: "requisites__content" }
const _hoisted_6 = { class: "requisites__block" }
const _hoisted_7 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_8 = { class: "requisites__content" }
const _hoisted_9 = ["readonly"]
const _hoisted_10 = { class: "requisites__block requisites__block--switcher" }
const _hoisted_11 = { class: "requisites__label text-capitalize-first" }
const _hoisted_12 = { class: "requisites__content requisites__content__switch" }
const _hoisted_13 = { class: "switch" }
const _hoisted_14 = {
  key: 0,
  class: "requisites__block requisites__block--switcher"
}
const _hoisted_15 = { class: "requisites__label text-capitalize-first" }
const _hoisted_16 = { class: "requisites__content requisites__content__switch" }
const _hoisted_17 = { class: "switch" }
const _hoisted_18 = {
  key: 1,
  class: "requisites__block"
}
const _hoisted_19 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_20 = { class: "requisites__content" }
const _hoisted_21 = { class: "requisites__controls" }
const _hoisted_22 = { class: "text-capitalize-first" }
const _hoisted_23 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_LoaderButton = _resolveComponent("LoaderButton")!
  const _component_Popup = _resolveComponent("Popup")!
  const _component_InviteLinkConfirmPopup = _resolveComponent("InviteLinkConfirmPopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Popup, {
      ref: (el) => _ctx.popup = el,
      class: "popup__lg",
      title: _ctx.form.id ? _ctx.$t('labels.edit_user', {req: _ctx.form.name}) : _ctx.$t('labels.create_user'),
      onOnClose: _ctx.hide
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("labels.name")), 1),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_FormInputWrapper, {
                  field: "name",
                  form: "userForm"
                }, {
                  default: _withCtx((parentProps) => [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                      class: _normalizeClass([parentProps.class, "form-control"]),
                      type: "text",
                      id: "name"
                    }, null, 2), [
                      [_vModelText, _ctx.form.name]
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("labels.email")), 1),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_FormInputWrapper, {
                  field: "email",
                  form: "userForm"
                }, {
                  default: _withCtx((parentProps) => [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.email) = $event)),
                      readonly: !!_ctx.form.id,
                      class: _normalizeClass([parentProps.class, "form-control"]),
                      type: "text",
                      id: "email"
                    }, null, 10, _hoisted_9), [
                      [_vModelText, _ctx.form.email]
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('labels.is_blocked')), 1),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.isBlocked) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.form.isBlocked]
                  ]),
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "slider" }, null, -1))
                ])
              ])
            ]),
            (!_ctx.form.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('labels.create_invite')), 1),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("label", _hoisted_17, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.createInvite) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.form.createInvite]
                      ]),
                      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "slider" }, null, -1))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.form.id || _ctx.form.createInvite === false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("labels.password")), 1),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_FormInputWrapper, {
                      field: "password",
                      form: "userForm"
                    }, {
                      default: _withCtx((parentProps) => [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.password) = $event)),
                          class: _normalizeClass([parentProps.class, "form-control"]),
                          type: "text",
                          id: "password"
                        }, null, 2), [
                          [_vModelText, _ctx.form.password]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("button", {
              class: "btn",
              type: "button",
              onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)), ["prevent"]))
            }, [
              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('button.cancel')), 1)
            ]),
            _createVNode(_component_LoaderButton, {
              "on-click": _ctx.save,
              class: "btn btn--accept"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('button.save')), 1)
              ]),
              _: 1
            }, 8, ["on-click"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["title", "onOnClose"]),
    _createVNode(_component_InviteLinkConfirmPopup, { ref: "inviteLinkConfirmPopup" }, null, 512)
  ], 64))
}